// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__3-4gA","footer":"ModalUpdate_footer__1vUFt"};